var S;!function(S){S.SVG="SVG",S.ICON_FONT="FA",S.SRC="SRC"}(S||(S={}));export{S as IconType};
